/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { FindCertificateRequestsByCertificateIdResponseDto } from "./FindCertificateRequestsByCertificateIdResponseDto.ts"

export const findCertificateRequestsByCertificateIdHttpControllerFindCertificateRequestsByCertificateIdQueryParamsStatusEnum =
  {
    OPENED: "OPENED",
    SUBMITTED: "SUBMITTED",
    REJECTED: "REJECTED",
    ACCEPTED: "ACCEPTED",
    CANCELED: "CANCELED",
  } as const

export type FindCertificateRequestsByCertificateIdQueryParamsStatusEnumKey =
  (typeof findCertificateRequestsByCertificateIdHttpControllerFindCertificateRequestsByCertificateIdQueryParamsStatusEnum)[keyof typeof findCertificateRequestsByCertificateIdHttpControllerFindCertificateRequestsByCertificateIdQueryParamsStatusEnum]

export type FindCertificateRequestsByCertificateIdQueryParams = {
  /**
   * @type string
   */
  certificateId: string
  /**
   * @type array | undefined
   */
  status?: FindCertificateRequestsByCertificateIdQueryParamsStatusEnumKey[]
}

export type FindCertificateRequestsByCertificateId200 =
  FindCertificateRequestsByCertificateIdResponseDto

export type FindCertificateRequestsByCertificateIdQueryResponse =
  FindCertificateRequestsByCertificateId200

export type FindCertificateRequestsByCertificateIdQuery = {
  Response: FindCertificateRequestsByCertificateId200
  QueryParams: FindCertificateRequestsByCertificateIdQueryParams
  Errors: any
}
